import { render, staticRenderFns } from "./AbandonedCartRecovery.vue?vue&type=template&id=066031ca"
import script from "./AbandonedCartRecovery.vue?vue&type=script&lang=js"
export * from "./AbandonedCartRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports